import { z } from 'zod';

export const TRANSFER_POLICY_VALUES = ['open', 'same_group_only', 'forbidden'] as const;
export const TRANSFER_PLAN_SCOPE_VALUES = ['dealer_own', 'national', 'foreign_group_own'] as const;

// A single forbidden-direction row. from_scope/to_scope are required enum members
// (mirrors required_with + Rule::enum).
const forbiddenDirectionSchema = z.object({
    from_scope: z.enum(TRANSFER_PLAN_SCOPE_VALUES, { message: 'Select a from scope' }),
    to_scope: z.enum(TRANSFER_PLAN_SCOPE_VALUES, { message: 'Select a to scope' }),
});

export const transferRuleSchema = z.object({
    transfer_in_allowed: z.boolean(), // required|boolean
    transfer_out_allowed: z.boolean(), // required|boolean
    // '' (the Select "Unset" option) → the form keeps '' and the service maps it to null,
    // mirroring nullable|Rule::enum. A non-empty value must be a TransferPolicy member.
    transfer_in_policy: z.enum(TRANSFER_POLICY_VALUES).or(z.literal('')),
    transfer_out_policy: z.enum(TRANSFER_POLICY_VALUES).or(z.literal('')),
    forbidden_directions: z.array(forbiddenDirectionSchema), // nullable|array (see shaping)
});

export type TransferRuleFormValues = z.infer<typeof transferRuleSchema>;
